<template>
    <div>
        <div class="relative">
            <swiper
                :options="swiperOptions"
                class="mySwiper"
            >
                <swiper-slide v-for="item in other.banner" :key="item.image">
                    <img class="swiper-img" :src="item.image"/>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination" />
            </swiper>
            <VBreadcrumb class="main-width absolute bread py-5" theme="white" :options="[{ label: '首页', to: '/' }, {label: '假日航线'}]"></VBreadcrumb>
            <div class="banner-name" v-if="other.banner">
                <h1>{{ other.banner[0].title }}</h1>
                <h2>{{ other.banner[0].title_en }}</h2>
            </div>
        </div>
        <section class="box">
            <div class="main-width">
                <div class="holday-filter">
                    <div class="filter-row" v-if="other.filter">
                        <filter-bar
                            name="假期选择"
                            :options="other.filter.holiday"
                            :is-all="queryData.date.length == 0"
                            @on-clear="handleClearQuery('date')"
                        >
                            <template #item="{option}">
                                <v-checkbox
                                    :val="option.value"
                                    v-model="queryData.date"
                                    @change="handleFitlerChange"
                                >
                                    {{ option.name }}
                                </v-checkbox>
                            </template>
                        </filter-bar>
                        <filter-bar
                            name="邮轮公司"
                            :options="other.filter.company"
                            :is-all="queryData.brand.length == 0"
                            @on-clear="handleClearQuery('brand')"
                        >
                            <template #item="{option}">
                            <v-checkbox
                                :val="option.id"
                                v-model="queryData.brand"
                                @change="handleFitlerChange"
                            >
                                {{ option.name }}
                            </v-checkbox>
                            </template>
                        </filter-bar>
                    </div>
                </div>
                <product-list
                    @change="listQueryChange"
                    :pageIndex="queryData.page_index"
                    :loading="loading"
                    :initSort='[queryData.sort_name]'
                    :sort_type="queryData.sort_type"
                    :listData="listData"
                >
                    <template #item="{info}">
                        <product-item
                            :info="info"
                            :loading="loading"
                        >
                            <template #info3>
                                <div class="info" v-if="info.date">
                                    <div class="info-title ">
                                        <span class="ficon ficon-ziyuancaigou_chufariqi in-icon"></span>
                                    </div>
                                    {{ formatDateToString(info.date) }}
                                    <div class="holiday-tag" v-for="i in info.tags" :key="i">{{ i }}</div>
                                </div>
                            </template>
                        </product-item>
                    </template>
                </product-list>
            </div>
        </section>

        <AppDock />
    </div>
</template>

<script>
import { defineComponent, useMeta, useFetch, ref } from '@nuxtjs/composition-api';
import FilterBar from "@/components/product/filterBar";
import ProductList from "@/components/product/productList";
import ProductItem from '@/components/product/prodcutItem.vue'
import VBreadcrumb from '@/components/VBreadcrumb.vue'

import { getHolidayProducts, getHolidayFilter } from "~/services/product";
import dayjs from 'dayjs';

import AppDock from '~/components/layouts/AppDock.vue'


export default defineComponent({
    name: 'holidayRoute',
    auth: false,
    head: {},
    layout: 'Main',
    components: { FilterBar,ProductList,ProductItem, VBreadcrumb, AppDock},
    setup() {
		useMeta(() => ({
			title: "假日航线"
		}));

        return {
            swiperOptions:{
                slidesPerView:3,
                spaceBetween:0,
                pagination:{
                    el: ".swiper-pagination",
                    clickable: true,
                },
                autoplay:true,
                lazy:true,
                loop: true,
            },
        }
    },
    data(){
        return {
            listData:{},
            other:{},
            queryData:{
                brand:[],
                date:[],
                sort_type:'',
                sort_name:'1',
                page_index:1,
                page_size:10
            },
            loading:true
        }
    },
    methods:{
        async getLists(params){
            this.$router.replace({
				path: "",
				query: {
					...params
				}
			});
            this.loading = true
            const { data, code, msg } = await getHolidayProducts(params)
            console.log('list data', data)
            this.loading = false
			if (code === 10000 || code === 200) {
				this.listData = data;
			} else {
				this.$message({
					type: "error",
					text: msg
				});
			}
        },
        handleClearQuery(key) {
            this.queryData[key] = [];
            this.$nextTick(this.handleFitlerChange);
        },
        handleFitlerChange() {
            this.queryData.page_index = 1
            this.getLists(this.queryData)
        },
        listQueryChange(val){
            this.queryData.page_index = val.page_index
            this.queryData.page_size = val.page_size
            this.queryData.sort_name = val.sort_name
            this.queryData.sort_type = val.sort_type

            this.getLists(this.queryData)

        },
        formatDateToString(date){
            let day = dayjs(date).day()
            let str = dayjs(date).format('YY/MM/DD')
            switch(day){
                case 0:
                    return `${str} 周日出发`
                case 1:
                    return `${str} 周一出发`
                case 2:
                    return `${str} 周二出发`
                case 3:
                    return `${str} 周三出发`
                case 4:
                    return `${str} 周四出发`
                case 5:
                    return `${str} 周五出发`
                case 6:
                    return `${str} 周六出发`
            }
        }
    },
    async fetch(){
        const { query } = this.$route;
        if(query.page_index){
            query.page_index = Number(query.page_index)
        }
        if(query.page_size){
            query.page_size = Number(query.page_size)
        }
        this.queryData = {...this.queryData,...query}
        await this.getLists(this.queryData)
        const { data, code, msg }  = await getHolidayFilter()
        if (code === 10000 || code === 200) {
            this.other =  data
        } else {
            this.$message({
                type: "error",
                text: msg
            });
        }
    }
})
</script>

<style lang="scss" scoped>
.bread {
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  z-index: 1;
}
.mySwiper {
  height: 320px;
}
.mySwiper .swiper-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.banner-name {
  color: #fff;
  border: 2px solid #FFFFFF;
  width: 265px;
  height: 130px;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 5;
  transform: translate(-50%,-50%);
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.banner-name h1 {
  font-size: 52px;
  font-weight: 500;
  line-height: 1;
  margin-bottom: 10px;
}
.banner-name h2 {
  font-size: 27px;
  line-height: 1;
}
.box {
  background-color: #fff;
  padding-bottom: 98px;
  padding-top: 40px;
}
.holday-filter {
  background: linear-gradient(180deg, #F3F5F8 0%, rgba(255,255,255,0) 100%);
  box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.1);
  border-radius: 20px 20px 0 0;
}
.holday-filter .filter-row {
  padding: 20px 28px;
}
.info {
  font-size: 16px;
  margin-bottom: 8px;
  padding-right: 286px;
  line-height: 24px;
  display: flex;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.info .ellips {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.info .in-icon {
  margin-right: 12px;
  font-size: 20px;
}
.info .info-title {
  white-space: nowrap;
}
.info .holiday-tag {
  display: inline-block;
  height: 22px;
  line-height: 22px;
  padding: 0 8px;
  font-size: 13px;
  color: #fff;
  text-align: center;
  background: linear-gradient(90deg, #F2007D 0%, #F2B203 100%);
  border-radius: 11px 2px 11px 11px;
  margin-left: 8px;
}
</style>